import { useTranslation } from 'react-i18next';
import { switchProps } from '../../config/config';
import Switch from 'react-switch';
import { NotificationSettings } from '../../../../api-types/models/UserDto';
import { ReactNode, useCallback, useEffect, useState } from 'react';
import { useUpdateNotificationSettingsMutation } from '../../../../api/userApi';

interface IProps {
    notifications: NotificationSettings;
}

export function Notifications({ notifications }: Readonly<IProps>): ReactNode {
    const [disabled, setDisabled] = useState<boolean>(false);
    const [notificationsCopy, setNotificationsCopy] =
        useState<NotificationSettings>(notifications);
    const { t } = useTranslation();
    const [updateNotificationSettings] =
        useUpdateNotificationSettingsMutation();

    const handleSavingNotificationsSettings = useCallback(() => {
        updateNotificationSettings(notificationsCopy)
            .unwrap()
            .then(() => setDisabled(true));
    }, [notificationsCopy, updateNotificationSettings]);

    useEffect(() => {
        setDisabled(notificationsCopy === notifications);
    }, [notificationsCopy, notifications]);

    return (
        <div className='notifications-options box'>
            <div className='options-title'>{t('notifications')}</div>
            {Object.keys(notificationsCopy).map((notificationKey) => {
                const key = notificationKey as keyof NotificationSettings;
                return (
                    <div className='options-text-switch' key={notificationKey}>
                        {t(notificationKey.toLowerCase())}
                        <Switch
                            checked={notificationsCopy[key] ?? false}
                            onChange={(value: boolean) =>
                                setNotificationsCopy({
                                    ...notificationsCopy,
                                    [key]: value
                                })
                            }
                            {...switchProps}
                        />
                    </div>
                );
            })}
            <button
                className='btn btn-blue'
                disabled={notifications === notificationsCopy || disabled}
                onClick={() => handleSavingNotificationsSettings()}
            >
                {t('save')}
            </button>
        </div>
    );
}
